module.exports = __webpack_public_path__ + "img/49d982a.jpg";